var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 0.527344)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18.5273C7.464 18.5273 4.001 14.2673 4.001 12.5273C4.001 10.5263 7.46 6.52734 12.001 6.52734C16.377 6.52734 19.999 10.5003 19.999 12.5273C19.999 14.2673 16.537 18.5273 12.001 18.5273H12ZM12.001 4.52734C6.48 4.52734 2 9.36834 2 12.5273C2 15.6133 6.576 20.5273 12 20.5273C17.423 20.5273 22 15.6133 22 12.5273C22 9.36834 17.52 4.52734 12 4.52734",
    fill: "#42526E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.977 14.5113C10.874 14.5113 9.977 13.6143 9.977 12.5113C9.977 11.4083 10.874 10.5113 11.977 10.5113C13.081 10.5113 13.977 11.4083 13.977 12.5113C13.977 13.6143 13.081 14.5113 11.977 14.5113ZM11.977 8.51134C9.771 8.51134 7.977 10.3053 7.977 12.5113C7.977 14.7173 9.771 16.5113 11.977 16.5113C14.184 16.5113 15.977 14.7173 15.977 12.5113C15.977 10.3053 14.184 8.51134 11.977 8.51134Z",
    fill: "#42526E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.09121f86.svg";
export { ForwardRef as ReactComponent };